module.exports = __webpack_public_path__ + "static/media/fitness.39f89d58.jpg";